import { Button, CircularProgress, makeStyles } from "@material-ui/core";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { sendFileToSignature } from "../../../../services/signature.service";
import {
  ConcludeButtonContainer,
  Header,
  HeaderCloseButton,
  ModalContentDiv,
  ModalTitle,
} from "./styles";

const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    minWidth: 180,
    minHeight: 50,
    borderRadius: 25,
  },
  buttonOutlined: {
    border: "2px solid",
    fontSize: "1rem",
    fontWeight: "bold",
    color: theme.palette.grey.main,
    textTransform: "capitalize",
    minWidth: 180,
    borderRadius: 25,
    minHeight: 50,
  },
}));

const SendToSignatureConfirmModal = ({
  minuteId,
  setSendToSignatureConfirmModal,
  setMessage,
  onSuccess,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [isSendingMinute, setIsSendingMinute] = useState();

  const handleSendFileToSignature = async () => {
    setIsSendingMinute(true);

    try {
      await sendFileToSignature(minuteId);

      setMessage({
        open: true,
        content: t("forms.minutes.signatures.sendToSignSuccess"),
        type: "success",
        autoHideDuration: 4000,
      });
      onSuccess();
    } catch (e) {
      const errorMessage =
        e.response.data.errors[0] ??
        t("forms.minutes.signatures.sendToSignError");

      setMessage({
        open: true,
        content: errorMessage,
        type: "error",
        autoHideDuration: 4000,
      });
    } finally {
      setSendToSignatureConfirmModal(false);
      setIsSendingMinute(false);
    }
  };

  return (
    <ModalContentDiv>
      <Header>
        <HeaderCloseButton
          onClick={() => {
            setSendToSignatureConfirmModal(false);
          }}
        >
          [X] {t("forms.minutes.signatures.sendToSignCloseModal")}
        </HeaderCloseButton>
      </Header>
      <ModalTitle>
        {t("forms.minutes.signatures.sendToSignSureQuestion")}
      </ModalTitle>
      <ConcludeButtonContainer>
        <Button
          className={classes.buttonOutlined}
          variant="outlined"
          onClick={() => setSendToSignatureConfirmModal(false)}
          disabled={isSendingMinute}
        >
          {t("forms.minutes.signatures.sendToSignCancelQuestion")}
        </Button>
        <Button
          className={classes.button}
          variant="contained"
          onClick={handleSendFileToSignature}
          disabled={isSendingMinute}
        >
          {isSendingMinute ? (
            <CircularProgress size={"1rem"} />
          ) : (
            t("forms.minutes.signatures.sendToSignConfirmQuestion")
          )}
        </Button>
      </ConcludeButtonContainer>
    </ModalContentDiv>
  );
};

export default SendToSignatureConfirmModal;
